<template>
  <div class="rank_main">
    <header>
      <navigation :text="'因子排行榜'" :searchShow="true"></navigation>
			<div class="nav_main">
        <ul id="nav_ul">
          <li
            :class="index === navId ? 'active' : ''"
            v-for="(item, index) in navList"
            :key="index"
            @click="checkNav(index)"
          >
            {{ item }}
          </li>
        </ul>
      </div>
    </header>
		<div :class="tableType === 'navTab' ? 'table_main navTab_show' : 'table_main'">
			<div class="table_content" v-if="tableType === 'small'">
				<table width="100%" cellspacing="0" cellpadding="0" class="table_header">
					<tr><th>因子名称</th><th>今日信号</th><th class="sort down">日涨幅%</th><th>操作</th></tr>
				</table>
				<table width="100%" cellspacing="0" cellpadding="0" class="table_tdMain">
					<!-- 排序按钮样式   up 箭头朝上  down箭头朝下 -->
					<tr v-for="(item,index) in tableList" :key="index">
						<td>
							<p>{{item.objName}}</p>
							<p>{{item.objStk}}</p>
						</td>
						<td>{{ item.jrxh }}</td>
						<td>{{item.rzf}}</td>
						<td>
							<span :class="item.finished ? 'active' : ''">{{ item.finished ? '已关注' : '关注'}}</span>
						</td>
					</tr>
				</table>
			</div>
			<div class="table_content table_lang" v-if="tableType === 'lang'">
				<table width="100%" cellspacing="0" cellpadding="0" class="table_header">
					<!-- 排序按钮样式   up 箭头朝上  down箭头朝下 -->
					<tr><th>因子名称</th><th>今日信号</th><th class="sort">日涨幅%</th><th class="sort">盈亏比</th><th>操作</th></tr>
				</table>
				<table width="100%" cellspacing="0" cellpadding="0" class="table_tdMain">
					
					<tr v-for="(item,index) in tableList" :key="index">
						<td>
							<p>{{item.objName}}</p>
							<p>{{item.objStk}}</p>
						</td>
						<td>{{ item.jrxh }}</td>
						<td>{{item.rzf}}</td>
						<td>{{item.ykb}}</td>
						<td>
							<span :class="item.finished ? 'active' : ''">{{ item.finished ? '已关注' : '关注'}}</span>
						</td>
					</tr>
				</table>
			</div>
			<ul class="nav_small_box" v-if="tableType === 'navTab'">
				<li :class="typeId === index ? 'active' : ''" v-for="(item,index) in typeList" :key="index" @click="checkType(index)">{{ item }}</li>
			</ul>
			<div class="table_content table_lang tab_table" v-if="tableType === 'navTab'">
				<table width="100%" cellspacing="0" cellpadding="0" class="table_header">
					<!-- 排序按钮样式   up 箭头朝上  down箭头朝下 -->
					<tr><th>因子名称</th><th>今日信号</th><th class="sort">日涨幅%</th><th class="sort">盈亏比</th><th>操作</th></tr>
				</table>
				<table width="100%" cellspacing="0" cellpadding="0" class="table_tdMain">
					<tr v-for="(item,index) in tableList" :key="index">
						<td>
							<p>{{item.objName}}</p>
							<p>{{item.objStk}}</p>
						</td>
						<td>{{ item.jrxh }}</td>
						<td>{{item.rzf}}</td>
						<td>{{item.ykb}}</td>
						<td>
							<span :class="item.finished ? 'active' : ''">{{ item.finished ? '已关注' : '关注'}}</span>
						</td>
					</tr>
				</table>
			</div>
		</div>
  </div>
</template>
<script>
import navigation from '@/components/navigation.vue';
export default {
  name: 'divisorRank',
  components: {
    navigation
  },
  data() {
    return {
			navList:["涨幅榜","短周期强势","中周期强势","长周期强势","近期点击最多","近期回测使用最多","高盈亏比","高阿尔法值","高贝塔值","高夏普比"],
			navId:0,
			tableList:[
				{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},
				{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: true,
				},
				{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},{
					objName:"广汽集团",
					objStk: "123456",
					jrxh: "0.42",
					rzf: "10.99%",
					ykb: "2.81",
					finished: false,
				},
			],
			tableType: "small", //small 为小型table  lang 为多th的table  navTab 为有子选择框table
			typeList:["全部","短周期","中周期","长周期"],
			typeId: 0
		};
  },
	created:function(){

	},
	mounted:function(){
		let domList = document.querySelectorAll(".nav_main li");
    let ul_w = 0;
    for (let i = 0; i < domList.length; i++) {
      let style = window.getComputedStyle(domList[i])
      ul_w = ul_w + domList[i].offsetWidth + parseInt(style.marginRight) + 1;
    }
    document.getElementById("nav_ul").style.width = ul_w + "px";
	},
	methods:{
		checkNav:function(id){
			this.navId = id;
			let doc = document;
      let WINDOW_OFFSETWIDTH = doc.documentElement.clientWidth;
      let liArr = doc.querySelectorAll(".nav_main li");
      let itemWidth = liArr[id].offsetWidth;
      let moveX = liArr[id].offsetLeft;
      let left = moveX - WINDOW_OFFSETWIDTH / 2 + itemWidth / 2;
      doc.getElementsByClassName("nav_main")[0].scrollLeft = left;
		},
		checkType:function(id){
			this.typeId = id;
		}
	}
};
</script>
<style lang="less" scoped>
.rank_main {
  width: 100%;
  height: 100%;
  header {
    padding-top: 0.88rem;
    .nav_main {
      width: 100%;
			overflow: hidden;
    	overflow-x: auto;
      ul {
        li {
          display: inline-block;
          height: 0.64rem;
          line-height: 0.64rem;
          text-align: center;
          font-size: 0.28rem;
					padding: 0 .52rem;
          color: #000;
          &.active {
            position: relative;
						color: #373A4D;
            &::before {
              content: "";
              width: 100%;
              height: 1px;
              position: absolute;
              bottom: 0;
              left: 0;
              background-color: #286df7;
            }
          }
        }
      }
    }
  }
	.table_main{
		background-color: #F4F4F4;
		padding-top: .24rem;
		height: calc(100% - 2.4rem);
		position: relative;
		&.navTab_show{
			height: calc(100% - 3.1rem);
		}
		.table_content{
			background-color: #FFF;
			padding-top: .5rem;
			height: 100%;
			overflow: hidden;
			overflow-y: scroll;
			.table_header{
				position: absolute;
				top: .24rem;
				left: 0;
				width: 100%;
				background-color: #FFF;
			}
			.table_tdMain{
				width: 100%;
				height: calc(100% - 0.5rem);
				overflow: hidden;
				overflow-y: scroll;
			}
			table{
				th{
					font-size: .24rem;
					color: #999999;
					font-weight: 400;
					padding: .08rem 0;
					&:first-child{
						padding-left: .3rem;
						box-sizing: border-box;
						text-align: left;
						width: 30%;
					}
					&:last-child{
						padding-right: .3rem;
						box-sizing: border-box;
						text-align: right;
						width: 25%;
					}
				}
				td{
					height: 1.14rem;
					text-align: center;
					font-size: .28rem;
					color: #555555;
					width: 22.5%;
					&:first-child{
						padding-left: .3rem;
						width: 30%;
						p{
							text-align: left;
							&:first-child{
								color: #555555;
								font-weight: 600;
								font-size: .28rem;
								line-height: .4rem;
							}
							&:last-child{
								color: #999999;
								font-weight: 600;
								font-size: .24rem;
								line-height: .34rem;
							}
						}
					}
					&:last-child{
						padding-right: .34rem;
						width: 25%;
						span{
							padding: .04rem .2rem;
							background-color: rgba(40, 109, 247, 0.06);
							color: #286DF7;
							border-radius: .04rem;
							float: right;
							&.active{
								background-color: rgba(153, 153, 153, 0.0588235);
								color: #999999;
							}
						}
					}
					
				}
			}
		}
		.nav_small_box{
			width: 100%;
			background-color: #F4F4F4;
			padding-bottom: .16rem;
			box-sizing: border-box;
			padding-left: .24rem;
			li{
				padding: .08rem .32rem;
				background-color: #FFF;
				color: #373A4D;
				border-radius: .04rem;
				font-size: .24rem;
				margin-right: .16rem;
				display: inline-block;
				&:last-child{
					margin-right: 0;
				}
				&.active{
					background-color: #286DF7;
					color: #FFF;
				}
			}
		}
		.table_lang{
			table{
				th{
					width: 16.66666666666667%;
					&:first-child{
						width: 25%;
					}
					&:last-child{
						width: 25%;
					}
				}
				.sort{
					&::before{
						right: 0 !important;
					}
				}
				td{
					width: 16.66666666666667%;
					&:first-child{
						width: 25%;
					}
					&:last-child{
						width: 25%;
					}
				}
			}
			&.tab_table{
				.table_header{
					top: .94rem;
				}
				
			}
		}
	}
}
</style>
